import { render, staticRenderFns } from "./unitList1.vue?vue&type=template&id=b3c237d2&scoped=true&"
import script from "./unitList1.vue?vue&type=script&lang=js&"
export * from "./unitList1.vue?vue&type=script&lang=js&"
import style0 from "./unitList1.vue?vue&type=style&index=0&id=b3c237d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c237d2",
  null
  
)

export default component.exports